import React, { Component, Fragment } from "react";
import { TextField, Modal, CircularProgress } from "@material-ui/core";
import * as API from "./apiGateway";
import _ from "lodash";

import validator from "validator";
import { getDistanceByKM } from "./calculations";
import Autocomplete, {
  createFilterOptions
} from "@material-ui/lab/Autocomplete";

const INITIAL_FORM_STATE = {
  stationId: LOADING_KEY,
  carNumber: "",
  personalCode: "",
  errors: {}
};

const UNKNOWN_ERROR =
  "קיימת תקלה.\nנסה במועד מאוחר יותר או התקשר למוקד דלקנים 09-8637757";
const FETCH_ERROR = "השרת אינו זמין כעת\nאנא נסו מאוחר יותר";
const LOADING_KEY = "loading";

const ResultModal = ({ text, onClose, isVisible }) => (
  <Modal open={isVisible} onClose={onClose}>
    <div className="flex flex-col items-center justify-center h-full">
      <div className="flex flex-col form-sent items-center justify-between py-10 text-center">
        <p>{text}</p>
        <div className="form-sent-button" onClick={onClose}>
          <p className="form-sent-text">לסגירה</p>
        </div>
      </div>
    </div>
  </Modal>
);

class DalkanVerifyForm extends Component {
  state = {
    ...INITIAL_FORM_STATE,
    allStations: [],
    formSent: false,
    sendingForm: false,
    showError: false,
    fetchError: false,
    errorMessage: "",
    showCarNumber: true
  };

  componentDidMount() {
    this._initializePhone();
    this._initializeGasStations();
    this._initializeSettings();
  }
  filter = createFilterOptions({
    stringify: (option) => option.name
  });

  render() {
    const {
      carNumber,
      errors,
      formSent,
      showError,
      sendingForm,
      errorMessage,
      personalCode,
      showCarNumber
    } = this.state;
    return (
      <form className="mx-auto text-right">
        <Autocomplete
          id="combo-box-demo"
          options={this.state.allStations}
          getOptionLabel={(option) => option.name}
          onChange={(e, val) => {
            if (val) {
              this.setState({ stationId: val.stationId });
            } else {
              this.setState({ stationId: LOADING_KEY });
            }
          }}
          style={{ width: "100%" }}
          filterOptions={this.filter}
          renderInput={(params) => {
            return (
              <TextField
                error={!_.isEmpty(errors.stationId)}
                helperText={errors.stationId}
                {...params}
                placeholder="רשימת תחנות"
              />
            );
          }}
        />
        {showCarNumber && (
          <TextField
            id="carNumber"
            value={carNumber}
            inputProps={{ maxLength: 12 }}
            error={!_.isEmpty(errors.carNumber)}
            helperText={errors.carNumber}
            placeholder={"מספר רכב"}
            onChange={this._handleChange("carNumber")}
            margin="normal"
            fullWidth
          />
        )}
        <TextField
          id="personalCode"
          placeholder="קוד אישי"
          error={!_.isEmpty(errors.personalCode)}
          helperText={errors.personalCode}
          value={personalCode}
          onChange={this._handleChange("personalCode")}
          margin="normal"
          fullWidth
        />
        <div
          onClick={this._handleSubmit}
          className="confirm-error-button text-center mx-auto"
        >
          {sendingForm ? (
            <CircularProgress
              className="confirm-text"
              size={18}
              color="secondary"
            />
          ) : (
            <p className="confirm-text">שלח</p>
          )}
        </div>
        <ResultModal
          isVisible={formSent}
          onClose={() => this.setState({ formSent: false })}
          text={<Fragment>בקשתך נקלטה.</Fragment>}
        />
        <ResultModal
          isVisible={showError}
          onClose={() => this.setState({ showError: false })}
          text={errorMessage}
        />
      </form>
    );
  }

  onClickCheckbox = () => {
    this.setState({ isUrea: !this.state.isUrea });
  };

  async _initializeSettings() {
    try {
      const settings = await API.getWebFormSettings();
      this.setState({ showCarNumber: settings.showCarNumber });
    } catch (err) {
      // default to showing the field if the request fails
    }
  }

  async _initializeGasStations() {
    try {
      let gasStations = await API.fetchGasStationsList();

      gasStations = await this._trySortStationsByDistance(gasStations);
      this.setState({
        allStations: gasStations,
        stationId: LOADING_KEY
      });
    } catch (err) {
      this.setState({ showError: true, errorMessage: FETCH_ERROR });
    }
  }

  async _trySortStationsByDistance(gasStations) {
    try {
      const location = await new Promise((resolve, reject) =>
        navigator.geolocation.getCurrentPosition(resolve, reject)
      );
      gasStations = _.sortBy(gasStations, (gasStation) =>
        getDistanceByKM(
          gasStation.latitude,
          gasStation.longitude,
          location.coords.latitude,
          location.coords.longitude
        )
      );
    } catch (error) {
      gasStations = _.sortBy(gasStations, (station) => station.name);
    }
    return gasStations;
  }

  _initializePhone() {
    const params = new URL(document.location).searchParams;
    let prefix = "",
      phone = "";

    if (params.get("phone")) {
      const userPhone = params.get("phone");
      prefix = userPhone.slice(0, 3);
      phone = userPhone.slice(3, 11);
    }
    this.setState({ prefix, phone });
  }

  _validateForm = () => {
    let errors = {};
    const { carNumber, stationId, personalCode, showCarNumber } = this.state;
    if (
      showCarNumber &&
      !validator.matches(carNumber, /^מ?\d{1,8}$|^\d{12}$/u)
    ) {
      errors.carNumber = "נא להזין מספר תקין";
    }
    if (!stationId || stationId === LOADING_KEY) {
      errors.stationId = "יש לבחור תחנה";
    }
    if (
      !validator.isNumeric(personalCode) ||
      !validator.isLength(personalCode, { min: 4 })
    ) {
      errors.personalCode = "נא להזין מספר תקין";
    }
    this.setState({ errors });
    return _.isEmpty(errors);
  };

  _handleChange = (name) => (event) => {
    this.setState({
      [name]: event.target.value
    });
  };

  _handleSubmit = async () => {
    if (this._validateForm()) {
      this.setState({ sendingForm: true, showError: false, errorMessage: "" });
      const { carNumber, stationId, personalCode, showCarNumber } = this.state;

      const dalkanInfo = {
        ...(showCarNumber && { carNumber }),
        stationId,
        personalCode
      };

      try {
        await API.sendVerifyDalkanForm(dalkanInfo);
        this.setState({
          ...INITIAL_FORM_STATE,
          formSent: true,
          sendingForm: false
        });
      } catch (err) {
        const errorString = _.get(err, "response.data.ReturnString");
        this.setState({
          showError: true,
          sendingForm: false,
          errorMessage: errorString || UNKNOWN_ERROR
        });
      }
    }
  };
}

export default DalkanVerifyForm;



// WEBPACK FOOTER //
// ./src/DalkanVerifyForm.js